import { render } from "./donation_campaigns.html?vue&type=template&id=708aae80&external"
import script from "./donation_campaigns.js?vue&type=script&lang=js&external"
export * from "./donation_campaigns.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__